import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CoreApisService } from '../core-apis.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-customer-onboarding',
  templateUrl: './customer-onboarding.component.html',
  imports: [CommonModule],
})
export class CustomerOnboardingComponent implements OnInit, OnDestroy {
  constructor(private coreApiPageService: CoreApisService) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  onboardingData: any;
  image:any;
  subscriptions: Subscription[];
  ngOnInit(): void {
    this.coreApiPageService.onboarding$.subscribe(data => {
      if (data !== null) {
        this.onboardingData = {
          tagName: data?.tags?.fields?.tagName,
          title: data?.richTextTitle?.content[0]?.content[0]?.value,
          description: data?.description?.content[0]?.content[0]?.value,
          image: data?.imageicon?.fields?.file?.url,
          button: data?.button[0]?.fields,
        };
      }
    });
  }
}
